import moment from 'moment'

export function noop() {}

function echo(s) {
  return s
}

export function makeNumberedOptions(length, start = 1, labelFunc = echo) {
  if (typeof labelFunc !== 'function') return []
  return Array.from({ length }).map((_, i) => ({
    label: labelFunc(i + start),
    value: i + start,
  }))
}

export function dateStr(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD')
}

// 级联的显示文本
export function getCascaderLabel(valueArr, options, sep = '/') {
  if (
    !(valueArr && Array.isArray(valueArr) && options && Array.isArray(options))
  ) {
    return null
  } else if (valueArr.length !== 2) {
    console.warn('cascader value is too long or short')
    return null
  }

  const labelArr = Array.from({ length: valueArr.length })
  let children = options
  let i = 0
  for (const value of valueArr) {
    const level = children.find(op => op.value === value)
    if (!level) return null

    children = level.children
    labelArr[i] = level.label
    i++
  }

  return labelArr.join(sep)
}

/**
 * 获取字段定义大全
 * @param {Array} fieldDefs
 * @return {Array}
 */
export function liftedFieldDefs(fieldDefs) {
  const neatFieldDefs = fieldDefs.filter(o => !o.fieldSet)
  const nestedFieldDefs = fieldDefs
    .filter(o => o.fieldSet)
    .reduce((y, x) => y.concat(x.fieldSet), [])
  const liftedFieldDefs = neatFieldDefs.concat(nestedFieldDefs)
  return liftedFieldDefs
}

/**
 * 自定义中获取字段
 * @param {Array} fieldDefs
 * @param {String} id
 * @return {Object}
 */
export function getFieldDef(fieldDefs, id) {
  if (!Array.isArray(fieldDefs)) {
    console.warn('fieldDefs 不是数组')
    return
  }

  const _fieldDefs = liftedFieldDefs(fieldDefs)
  return _fieldDefs.find(o => o.id === id)
}

/**
 * 将周期转换成月数
 * @param {String} cycle
 * @return {Number}
 */
export function cycle2Number(cycle) {
  const dict = {
    ONEMON: 1,
    TWOMON: 2,
    FOURMON: 4,
    THREEMON: 3,
    SIXMON: 6,
    TWELVEMON: 12,
    ONEPAY: null,
  }
  return dict[cycle]
}

/**
 * is numbers match
 * @param a
 * @param b
 * @param precision
 */
export function isMatch(a, b, precision = 2) {
  return a.toFixed(precision) === b.toFixed(precision)
}

export function trim(s) {
  return typeof s === 'string' ? s.trim() : s
}

// get label from options or undefined
export function getLabel(value, options) {
  if (!(options && Array.isArray(options))) {
    return
  } else {
    const opt = options.find(op => op.value === value)
    if (opt) {
      return opt.label
    }

    return
  }
}

// get date timestamp
export function getTime(dateObj) {
  if (!dateObj) return undefined
  return dateObj instanceof Date ? dateObj.getTime() : dateObj
}

export function isDate(objType) {
  return objType === Date
}

export const isObject = obj =>
  obj && !Array.isArray(obj) && typeof obj === 'object'



// WEBPACK FOOTER //
// ./src/page/none/workflow/trusteeship/forms/utils.js